import React from 'react';

const RadioOnIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 1 32 32" style={this.props.style||{}}>
				<path d="M16,5A11,11,0,1,0,27,16,11.01245,11.01245,0,0,0,16,5Zm0,19a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,16,24Zm5-8a5,5,0,1,1-5-5A5,5,0,0,1,21,16Z"/>
			</svg>
		);
	}
}

export default RadioOnIcon;
